import WhatsAppButton from './components/WhatsAppButton';
import ModalRestriccion from './components/ModalRestriccion';
import LandingPage from './pages/LandingPage';
import AdminPanel from './pages/AdminPanel';
import AdminDashboard from './pages/AdminDashboard';
import AdminClientes from './pages/AdminClientes';
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Registro from './pages/Registro';
import Dashboard from './pages/Dashboard';
import Cotizar from './pages/Cotizar';
import CrearEnvio from './pages/CrearEnvio';
import MisEnvios from './pages/MisEnvios';  // NUEVO
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Saldo from './pages/Saldo';
import SaldoExito from './pages/SaldoExito';
import EnvioExitoso from './pages/EnvioExitoso';
import './App.css';

// Componente para rutas protegidas
function ProtectedRoute({ children }) {
  const { token, loading } = useAuth();

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">Cargando...</div>;
  }

  return token ? children : <Navigate to="/login" />;
}

// Componente para rutas públicas (TEMPORALMENTE SIN REDIRECCIÓN)
function PublicRoute({ children }) {
  const { token, loading } = useAuth();

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">Cargando...</div>;
  }

  // TEMPORALMENTE: solo mostramos el componente sin redirigir
  return children;
}
function AuthRedirect() {
  const { token, loading } = useAuth();
  
  if (loading) {
    return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Cargando...</div>;
  }
  
  return token ? <Navigate to="/dashboard" /> : <LandingPage />;
}
function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Rutas públicas */}
          <Route 
            path="/login" 
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            } 
          />
          <Route
            path="/registro"
            element={
              <PublicRoute>
                <Registro />
              </PublicRoute>
            }
          />
          <Route
            path="/forgot-password"
            element={
              <PublicRoute>
                <ForgotPassword />
              </PublicRoute>
            }
          />
          <Route
            path="/reset-password"
            element={
              <PublicRoute>
                <ResetPassword />
              </PublicRoute>
            }
          />

          {/* Rutas protegidas */}
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/cotizar" 
            element={
              <ProtectedRoute>
                <Cotizar />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/crear-envio" 
            element={
              <ProtectedRoute>
                <CrearEnvio />
              </ProtectedRoute>
            } 
          />
          <Route 
  path="/saldo" 
  element={
    <ProtectedRoute>
      <Saldo />
    </ProtectedRoute>
  } 
/>
<Route 
  path="/saldo/exito" 
  element={
    <ProtectedRoute>
      <SaldoExito />
    </ProtectedRoute>
  } 
/>
          {/* NUEVA RUTA */}
          <Route 
            path="/mis-envios" 
            element={
              <ProtectedRoute>
                <MisEnvios />
              </ProtectedRoute>
            } 
          />
          <Route
  path="/admin"
  element={
    <ProtectedRoute>
      <AdminPanel />
    </ProtectedRoute>
  }
/>
<Route
  path="/admin/dashboard"
  element={
    <ProtectedRoute>
      <AdminDashboard />
    </ProtectedRoute>
  }
/>
<Route
  path="/admin/clientes"
  element={
    <ProtectedRoute>
      <AdminClientes />
    </ProtectedRoute>
  }
/>
<Route
  path="/envio-exitoso"
  element={
    <ProtectedRoute>
      <EnvioExitoso />
    </ProtectedRoute>
  }
/>
          {/* Ruta por defecto */}
          <Route path="/" element={<AuthRedirect />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <WhatsAppButton />
        <ModalRestriccion />
      </Router>
    </AuthProvider>
  );
}

export default App;